import { mergeObjects } from 'ui/utilities/helpers';

import type { UtilLinks } from 'core';

export const getDataNavbarMerged = (
  links: UtilLinks[] | null | undefined,
  objMenuLinks: string,
): UtilLinks[] => {
  if (!links) return [];

  try {
    const objDefault = JSON.parse(objMenuLinks);
    const isMergeLinks = objDefault?.flag && objDefault?.menu;

    return isMergeLinks ? Object.values(mergeObjects(links, objDefault?.menu?.links)) : links;
  } catch (error) {
    return links;
  }
};
